import { createContext, useContext, useState, type ReactNode } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import AuthGuard from "./AuthGuard";

const SidebarContext = createContext({ collapsed: false, width: 260 });

export function useSidebarLayout() {
  return useContext(SidebarContext);
}

export default function Layout() {
  const [collapsed, setCollapsed] = useState(false);
  const width = collapsed ? 72 : 260;

  return (
    <AuthGuard>
      <SidebarContext.Provider value={{ collapsed, width }}>
        <div className="flex min-h-screen bg-[var(--color-bg-primary)] print:bg-white">
          <div className="print:hidden">
            <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
          </div>
          <main
            className="flex-1 transition-all duration-300 print:!ml-0"
            style={{ marginLeft: width }}
          >
            <div className="p-8 print:p-0">
              <Outlet />
            </div>
          </main>
        </div>
      </SidebarContext.Provider>
    </AuthGuard>
  );
}
